/**
 * Address Book extension (user.extensions.address_book): switches the third-party address books in
 * the Address Book modal (Microsoft 365, Google, iCloud and Yahoo Contacts). Sendlinx Contacts,
 * Recent Recipients, Favourites, Groups and Import are always available.
 *
 * Off by default. Personal accounts turn it on in Extensions; in a business account the owner's
 * switch applies to every employee (the API reports managed_by_owner). "offered" is 0 when the
 * extension is switched off in Admin > Extensions. The API enforces the same rules (403
 * reason "extension_disabled"); this only decides what the UI shows.
 */
import { isContactsMockMode } from "./contactsApi";
import { isMs365MockMode } from "./ms365Api";
import { isGoogleMockMode } from "./googleContactsApi";
import { isICloudMockMode } from "./icloudContactsApi";
import { isYahooMockMode } from "./yahooContactsApi";

export const ADDRESS_BOOK_EXTENSION_KEY = "address_book";
export const THIRD_PARTY_VIEWS = ["microsoft", "google", "icloud", "yahoo"];
export const EXTENSIONS_PATH = "/user/extensions";

const truthy = (v) => v === true || v === 1 || v === "1";
const anyMock = () => {
    try{ return isContactsMockMode() || isMs365MockMode() || isGoogleMockMode() || isICloudMockMode() || isYahooMockMode(); }catch(e){ }
    return false;
};

/** Employees of a business account (same check as Extensions.js / FAR). */
export const isEmployeeAccount = (user) => !!(user && user.hasOwnProperty("businessUser") && user.businessUser !== null && user.member_type !== "business");

/** { enabled, offered, canManage, managedByOwner } for the signed-in user. */
export const getAddressBookAccess = (user) => {
    if(anyMock()){
        return { enabled: true, offered: true, canManage: true, managedByOwner: false };
    }
    const ext = user && user.extensions ? user.extensions[ADDRESS_BOOK_EXTENSION_KEY] : null;
    const managedByOwner = !!(ext && truthy(ext.managed_by_owner)) || isEmployeeAccount(user);
    const offered = !(ext && (ext.offered === 0 || ext.offered === "0" || ext.offered === false));
    return { enabled: offered && !!(ext && truthy(ext.status)), offered, canManage: !managedByOwner, managedByOwner };
};

export const isAddressBookEnabled = (user) => getAddressBookAccess(user).enabled;
